<style global lang="postcss">
    body {
        min-width: 350px;
        margin: 0; /* Entfernt den Standardrand */

        /* Hintergrund-Gradient */
        background: radial-gradient(circle at center, #f4c578 0%, #f1cd93 70%, #faf9e5 100%);
        text-align: center;
    }
    .bordered-container {
        position: relative;
        background: #faf9e5;
        z-index: 0;
    }
    .bordered-container::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        width: 157px; /* Breite des Rahmens */
        background: url('/build/rahmen-links.png') repeat-y;
        z-index: -1;
    }

    .bordered-container::after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        width: 157px; /* Breite des Rahmens */
        background: url('/build/rahmen_rechts.png') repeat-y;
        z-index: -1;
    }

    .bordered-container::before {
        left: 0;
    }

    .bordered-container::after {
        right: 0;
    }
</style>

<script lang="ts">
    import Router from 'svelte-spa-router'
    import Home from './Home.svelte'

    import { onMount } from 'svelte'
    import Administration from './Administration.svelte'
    import { isAuthenticated } from './component/stores/authStore' // Import the store
    import Header from './component/Header.svelte'
    import AboutUs from './AboutUs.svelte'
    import ImagePlacer from './component/ImagePlacer.svelte'
    import Blog from './Blog.svelte'
    import Agb from './Agb.svelte'
    import Widerrufsbelehrung from './Widerrufsbelehrung.svelte'
    import BlogPost from './BlogPost.svelte'
    import Datenschutz from './Datenschutz.svelte'
    import BlogPostPreview from './BlogPostPreview.svelte'
    import Tracking from './component/Tracking.svelte'
    import Shop from './shop/routes/Shop.svelte'
    import Checkout from './shop/routes/checkout/index.svelte'
    import Payment from './shop/routes/payment/index.svelte'
    import ProductPage from './shop/routes/product/productPage.svelte'

    import wrap from 'svelte-spa-router/wrap'
    import { cookieConsent, loadInitialConsent, redirect, showModal } from './component/stores/cookieCheker'

    import CookieeBanner from './CookieeBanner.svelte'

	import { writable } from 'svelte/store';

	const canonicalUrl = writable('https://www.specker-bienchen.de/');

    let isAllAccepted = false



    $: $cookieConsent, (isAllAccepted = $cookieConsent.allAccepted)


    function checkConsentForShop(param = '') {
        // Greife auf die Cookie-Zustimmung zu

        if ($cookieConsent.necessaryAccepted && !$cookieConsent.allAccepted) {
            // Zeige den Cookie-Banner an, wenn nur notwendige Cookies akzeptiert wurden
            window.location.hash = '/'
            if (param !== '') {
                redirect.set({ toLocation: param}); 
            }
            showModal.set(true)
            return false // Blockiere den Zugriff
        }
        return true // Erlaube den Zugriff, wenn alle Cookies akzeptiert wurden
    }

    
    const routes = {
        '/': Home,
        '/admin/tracking': Tracking,
        '/ueber-uns': AboutUs,
        '/datenschutz': Datenschutz,
        '/wiederrufsbelehrung': Widerrufsbelehrung,
        '/agb': Agb,
        '/administration': Administration,
        '/blog': Blog,
        '/blog/:slug': BlogPost,
        '/blog/preview/:slug': BlogPostPreview,

        // Payment-Route: Zugriff nur, wenn alle Cookies akzeptiert wurden
        '/payment': wrap({
            component: Payment,
            conditions: [
                () => checkConsentForShop()  // Überprüft sowohl Cookie-Zustimmung als auch Ablauf des Countdowns
            ]
        }),

        // Shop-Route: Zugriff nur, wenn alle Cookies akzeptiert wurden
        '/shop': wrap({
            component: Shop,
            conditions: [
                () => checkConsentForShop('/shop')  // Überprüft sowohl Cookie-Zustimmung als auch Ablauf des Countdowns
            ]
        }),

        // Checkout-Route: Zugriff nur, wenn alle Cookies akzeptiert wurden und der Countdown abgelaufen ist
        '/checkout': wrap({
            component: Checkout,
            conditions: [() => checkConsentForShop() ]
        }),

        // Produktseite: Zugriff nur, wenn alle Cookies akzeptiert wurden und der Countdown abgelaufen ist
        '/product/:productId': wrap({
            component: ProductPage,
            conditions: [() => checkConsentForShop() ]
        })
    }

    onMount(() => loadInitialConsent())

    onMount(() => {
        const update = () => {
            const base = window.location.origin
            const hash = window.location.hash || '/'
            canonicalUrl.set(`${base}${hash}`)
        }
        update()
        window.addEventListener('hashchange', update)
        return () => window.removeEventListener('hashchange', update)
    })
</script>
<svelte:head>
  <link rel="canonical" href={$canonicalUrl} />
</svelte:head>
<Header />

<section class="min-h-[calc(100vh-74px)] mt-[74px] overflow-hidden md:overflow-visible bordered-container max-w-screen-lg container mx-auto py-4 px-20 md:px-32">
    <Router routes="{routes}" />

    <ImagePlacer
        img="{{
            title: 'Boden',
            description: 'Eine Bodenplate',
            url: '/build/boden.png'
        }}"
        y="{-5}"
        positionY="bottom"
        class="absolute left-1/2 bottom-0 transform -translate-x-1/2  !max-w-none !w-[120%] !lg:w-[110%] !xl:w-auto" />
</section>

<CookieeBanner />
